import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
interface Props {
  maintenanceMode: boolean | undefined;
}

const MaintenanceIndicator: React.SFC<Props> = ({ maintenanceMode, ...rest }) => {
  switch (maintenanceMode) {
    case true:
      return (
          <>
        <div>
        <FontAwesomeIcon className="text-secondary" icon={["fal", "tools"]} />
        </div>
    </>

      );
    case false:
      return (
        <>
          {/* <div>
          <FontAwesomeIcon
               className="text-success"
               icon={["fal", "check-circle"]}
             />
          </div> */}
      </>
      );
    default:
      return (
        <>
            <div>
              <FontAwesomeIcon
                className="text-muted"
                icon={["fal", "question-circle"]}
              />
            </div>
        </>
      );
  }
};

export default MaintenanceIndicator;
